import 'scss/services/idCardRecg.scss'
import 'babel-polyfill'
import {
  serviceTopbar
} from 'js/libs/utils-services'
import { goServiceBuy } from 'js/libs/utils-services-buy'
import { config } from 'config'

$(function () {
  $('.answer-table .buy-btn').click(function () {
    let packageId = $(this).data('packageId')
    let params = {
      wareId: '1103',
      packageId: packageId,
      serviceName: '身份证识别 intsig',
      businessId: 'idcard'
    }
    goServiceBuy(params)
  })
  serviceTopbar()
})



// WEBPACK FOOTER //
// ./src/js/entry/services/idCardRecg.js